<template lang="pug">
  .company-details
    v-layout.py-2.mb-6.company-header
      v-flex.sm6
        h2.primary--text {{ title }}

      v-flex.text-right.sm6(v-if="!id || companyEdited > 0")
        v-btn.mr-2(v-if="!!id" color="primary" @click="loadCompanyDetails") Rückgängig
        v-btn(color="primary" @click="onSaveCompany") Speichern

    v-form(ref="form-company" lazy-validation @submit.prevent="() => {}")
      v-expansion-panels.mt-4(v-model="panel" flat tile multiple)
        v-expansion-panel
          v-expansion-panel-header.company-panel-header Unternehmen
          v-expansion-panel-content(eager)
            v-row.mt-6
              v-col.pb-0(cols="12" sm="6")
                v-text-field(
                  v-model="company.company_name"
                  label="Firmenname"
                  outlined
                  :rules="[ rules.required ]"
                )
                v-text-field.mt-3(
                  v-model="company.company_website"
                  label="Firmenwebseite"
                  outlined
                )
                v-row
                  v-col.pb-0(cols="12" sm="6"): v-checkbox(
                    v-model="company.ewe_granted"
                    label="Ewe erteilt"
                    outlined
                    hide-details
                    @change="onChangeEveGranted"
                  )
                  v-col.pb-0(cols="12" sm="6"): n-date-picker(
                    ref="ewe_granted_at"
                    v-model="company.ewe_granted_at"
                    label="EwE erteilt am"
                    format="YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
                    :disabled="!company.ewe_granted"
                    :input-rules="[ company.ewe_granted ? rules.required : true ]"
                  )

              v-col.pb-0(cols="12" sm="6")
                n-image-upload(
                  :companyId="id"
                  :file="logoSrc"
                  @uploadOnCreation="saveLogo"
                  @reset="resetLogo"
                )

            h4.primary--text.mt-6 Ansprechpartner

            template(v-for="(contact, index) in company.contacts")
              v-divider.mt-4.mb-2(v-if="index > 0" :key="`hr-${ index }`")

              v-row.align-center.mt-1(:key="index")
                v-col.pb-0(cols="12" sm="6" md="3"): v-select(
                  v-model="contact.salutation"
                  label="Anrede"
                  outlined
                  :items="salutations"
                  :rules="[ rules.required ]"
                )

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="contact.academic_title"
                  label="Titel"
                  outlined
                )

                v-col.pb-0(cols="12" sm="6" md="3"): v-select(
                  v-model="contact.role"
                  label="Rolle"
                  outlined
                  :items="roles"
                  :rules="[ rules.required ]"
                )

                v-col.d-none.d-md-block.pb-0(md="3")

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="contact.forename"
                  label="Vorname"
                  outlined
                  :rules="[ rules.required ]"
                )

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="contact.lastname"
                  label="Nachname"
                  outlined
                  :rules="[ rules.required ]"
                )

                v-col.pb-0(cols="12" sm="6" md="3"): n-date-picker(
                  v-model="contact.birthday"
                  label="Geburtsdatum"
                  format="YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
                )

                v-col.d-none.d-md-block.pb-0(md="3")

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="contact.email"
                  label="Email"
                  outlined
                  :rules="[ rules.email ]"
                )

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="contact.telefone_nr"
                  label="Telefon"
                  outlined
                )

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="contact.mobile_nr"
                  label="Mobiltelefon"
                  outlined
                )

                v-col.d-none.d-md-block.pt-1.pb-0(cols="12" sm="6" md="3")
                  a.d-flex.align-center(v-if="index === 0" @click="onAddContact")
                    i.fo.fo-plus.primary--text
                    span.ml-1 Weiterer Ansprechpartner

                  a.d-flex.align-center(v-else @click="onRemoveContact(index)")
                    i.fo.fo-minus.primary--text
                    span.ml-1 Ansprechpartner entfernen

                v-col.d-block.d-md-none.pt-1.pb-0(cols="12" sm="6" md="3")
                  a.d-flex.align-center(v-if="index === 0" @click="onAddContact")
                    i.fo.fo-plus.primary--text
                    span.ml-1 Weiterer Ansprechpartner

                  a.d-flex.align-center(v-else @click="onRemoveContact(index)")
                    i.fo.fo-minus.primary--text
                    span.ml-1 Ansprechpartner entfernen

        template(v-for="(location, locIndex) in company.locations")
          v-expansion-panel.mt-3(:key="locIndex")
            v-expansion-panel-header.company-panel-header.pr-4: v-layout
              span Standort {{ location.name ? `(${ location.name })` : '' }}
              v-spacer
              a.icon-location-remove(
                v-if="!location.is_main_location"
                title="Standort entfernen"
                @click.stop="onRemoveLocation(locIndex)"
              )
                v-icon remove_circle

            v-expansion-panel-content(eager)
              v-row.align-center.mt-6
                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="location.name"
                  label="Name oder Bezeichnung des Standortes"
                  outlined
                  :rules="[ rules.required ]"
                  :id="`location-name-${ locIndex }`"
                )

                v-col.pt-0.pt-sm-3(cols="12" sm="6" md="3"): v-checkbox.mt-0.mt-sm-4.mb-4(
                  v-model="location.has_buildings"
                  label="Befinden sich Gebäude auf dem Standort?"
                  hide-details
                  @change="(v) => onChangeHasBuilding(locIndex, v)"
                )

                v-col.pt-0.pt-sm-3(cols="12" sm="6" md="3"): v-checkbox.mt-0.mt-sm-4.mb-4(
                  v-model="location.is_main_location"
                  label="Handelt es sich um den Hauptstandort?"
                  hide-details
                  :readonly="company.locations.length === 1"
                  @change="(v) => onSelectLocation(locIndex, v)"
                )

              h4.primary--text.mt-6 Adresse des Standortes

              v-row.align-center.mt-1
                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="location.street"
                  label="Straße"
                  outlined
                  :rules="[ rules.required ]"
                )

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="location.plz"
                  label="PLZ"
                  outlined
                  :rules="[ rules.required ]"
                )

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="location.city"
                  label="Ort"
                  outlined
                  :rules="[ rules.required ]"
                )

                v-col.d-none.d-md-block.pb-0(md="3")

                v-col.pb-0(cols="12" sm="6" md="3"): v-combobox(
                  v-model="location.country"
                  label="Land"
                  outlined
                  :items="countries"
                  :rules="[ rules.required ]"
                )

              h4.primary--text.mt-6 Gebäude

              template(v-for="(building, bldIndex) in location.buildings")
                v-divider.mt-4.mb-2(v-if="bldIndex > 0" :key="`building-hr-${ bldIndex }`")

                v-row.align-center.mt-1(:key="`building-${ bldIndex }`")
                  v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                    v-model="building.name"
                    label="Name oder Bezeichnung des Gebäudes"
                    outlined
                    :id="`building-${ locIndex }-${ bldIndex }`"
                    :rules="[ rules.required ]"
                  )

                  v-col.pt-1.pb-0(cols="12" sm="6" md="3")
                    a.d-flex.align-center(v-if="bldIndex === 0" @click="onAddBuilding(locIndex)")
                      i.fo.fo-plus.primary--text
                      span.ml-1 Weiteres Gebäude

                    a.d-flex.align-center(v-else @click="onRemoveBuilding(locIndex, bldIndex)")
                      i.fo.fo-minus.primary--text
                      span.ml-1 Gebäude entfernen

        v-layout.mt-4
          v-spacer
          a.d-flex.align-center(@click="onAddLocation")
            i.fo.fo-plus.primary--text
            span.ml-1 Weiterer Standort

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import Urls from '@/router/urls'
import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    NImageUpload: () => import('@/components/common/n-company-image-upload')
  },

  watch: {
    company: {
      deep: true,
      handler () {
        this.companyEdited = this.companyEdited + 1
      }
    }
  }
})
export default class CompanyDetails extends Vue {
  @Prop({ type: [ Number, String ], default: 0 }) id

  company = {
    ewe_granted: false,
    ewe_granted_at: '',

    contacts: [
      {
        salutation: '',
        academic_title: '',
        role: '',
        forename: '',
        lastname: '',
        birthday: null,
        email: '',
        telefone_nr: '',
        mobile_nr: ''
      }
    ],
    locations: [
      {
        name: '',
        has_buildings: true,
        is_main_location: true,
        street: '',
        plz: '',
        city: '',
        country: 'Deutschland',
        buildings: [
          {
            name: '',
          }
        ],
      }
    ]
  }

  companyEdited = 0
  panel = [0, 1]
  logoBlob = null
  logoSrc = null
  imageName = ''

  get title () {
    if (!this.id) {
      return 'Kunden anlegen'
    }

    return this.company && this.company.id
      ? `Kunden bearbeiten (${ this.company.company_name })`
      : `Kunden bearbeiten`
  }

  created () {
    if (this.id) {
      this.loadCompanyDetails()
    }
  }

  loadCompanyDetails () {
    this.$axios
      .get(Urls.Company(this.id))
      .then(res => {
        this.company = res.data
        if (this.company.logo) {
          this.loadCompanyLogo()
        }
        this.$nextTick(() => {
          this.companyEdited = 0
        })
      })
  }

  loadCompanyLogo () {
    this.$axios
      .fetchFile(Urls.CompanyLogo(this.id))
      .then(res => res.blob())
      .then(result => { this.logoSrc = URL.createObjectURL(result) })
  }

  onChangeEveGranted () {
    if (!this.company.ewe_granted) {
      this.company.ewe_granted_at = null
    }
  }

  onAddContact () {
    const { contacts } = this.company

    contacts.push({
      salutation: '',
      academic_title: '',
      role: '',
      forename: '',
      lastname: '',
      birthday: null,
      email: '',
      telefone_nr: '',
      mobile_nr: ''
    })

    this.company.contacts = contacts
  }

  onRemoveContact (index) {
    this.company.contacts.splice(index, 1)

    this.company = {
      ...this.company
    }
  }

  onAddLocation () {
    const { locations } = this.company

    locations.push({
      name: '',
      is_main_location: false,
      has_buildings: true,
      street: '',
      plz: '',
      city: '',
      country: 'Deutschland',
      buildings: [
        {
          name: '',
        }
      ],
    })

    this.company.locations = locations

    this.panel = this.panel.filter(p => p === 0)
    this.panel = [
      ...this.panel,
      locations.length
    ]

    this.$nextTick(() => {
      const elId = `location-name-${ locations.length - 1 }`
      this.scrollToField(elId)

      this.$nextTick(() => {
        const el = document.getElementById(elId)
        if (el) {
          el.focus()
        }
      })
    })
  }

  onRemoveLocation (index) {
    const handleRemoveLocation = () => {
      this.company.locations.splice(index, 1)

      this.company = {
        ...this.company
      }
      this.$confirmDialog.close()
    }

    this.$confirmDialog.show({
      text: 'Wollen Sie den Standort wirklich entfernen?',
      handleOk: handleRemoveLocation
    })
  }

  onAddBuilding (locIndex) {
    const { locations } = this.company
    const { buildings } = locations[locIndex]

    buildings.push({
      name: '',
    })

    locations[locIndex].buildings = buildings
    this.company.locations = locations

    this.$nextTick(() => {
      const newBuildingId = `building-${ locIndex }-${ buildings.length - 1 }`
      this.scrollToField(newBuildingId)
      this.$nextTick(() => {
        const el = document.getElementById(newBuildingId)
        if (el) {
          el.focus()
        }
      })
    })
  }

  onRemoveBuilding (locIndex, bldIndex) {
    const { locations } = this.company
    const { buildings } = locations[locIndex]

    buildings.splice(bldIndex, 1)
    locations[locIndex].buildings = buildings

    this.company.locations = locations

    this.company = {
      ...this.company
    }
  }

  onChangeHasBuilding (locIndex, value) {
    const { locations } = this.company
    if (value) {
      if (locations[locIndex].buildings && locations[locIndex].buildings.length) {
        return
      }
      locations[locIndex].buildings = [{
        name: '',
      }]
    } else {
      locations[locIndex].buildings = []
    }

    this.company = {
      ...this.company
    }
  }

  onSelectLocation (locIndex, value) {
    const { locations } = this.company
    if (value) {
      locations.map((l, i) => {
        if (i !== locIndex) {
          l.is_main_location = false
        }
        return l
      })
    } else {
      const id = locations.findIndex((_, i) => locIndex !== i)
      if (id >= 0) {
        locations[id].is_main_location = true
      }
    }

    this.company = {
      ...this.company
    }
  }

  onSaveCompany () {
    if (!this.isFormValid('form-company')) {
      return
    }

    if (!this.$refs['ewe_granted_at'].isFormValid('form-date')) {
      return
    }

    const params = {
      ...this.company
    }

    if (!this.company.ewe_granted) {
      params.ewe_granted_at = null
    }

    if (this.id) {
      this.handleUpdateCompany(params)
    } else {
      this.handleAddCompany(params)
    }
  }

  saveLogo (blob, fileName) {
    this.logoBlob = blob
    this.imageName = fileName
  }

  resetLogo () {
    this.logoBlob = null
    this.imageName = ''
    if (this.id) {
      this.submitImage(this.id)
    }
  }

  handleAddCompany (params) {
    this.$axios
      .post(Urls.Company(), params)
      .then(async (res) => {
        this.$toast.success('Daten gespeichert', 'Speichern')
        this.loadCompanies()
        if (this.logoBlob) {
          await this.submitImage(res.data.id)
        }
        this.$router.push({
          name: 'company-list'
        })
      })
      .catch(err => {
        this.$toast.error(err.message, 'Fehler')
      })
  }

  async submitImage (companyId) {
    const params = new FormData()

    if (this.imageName) {
      params.append('logo', this.logoBlob, this.imageName)
    }

    await this.$axios
      .post(Urls.CompanyLogo(companyId), params, true)
  }

  handleUpdateCompany (params) {
    this.$axios
      .put(Urls.Company(this.id), params)
      .then(() => {
        this.$toast.success('Daten gespeichert', 'Speichern')
        this.loadCompanies()
        this.loadCompanyDetails()

        if (this.selectedCompany && this.selectedCompany.id === parseInt(this.id)) {
          this.selectCompany({
            id: this.selectedCompany.id,
            name: params.company_name
          })
        }
      })
      .catch(err => {
        this.$toast.error(err.message, 'Fehler')
      })
  }
}
</script>

<style lang="sass">
.company-header
  position: sticky
  top: 0
  z-index: 3
  background-color: #ffffff

.company-panel-header
  position: sticky !important
  top: 52px
  z-index: 2

.icon-location-remove
  position: absolute
  right: 10px
  top: 12px
  color: inherit !important

  .v-icon
    color: inherit !important
</style>
